import { render, staticRenderFns } from "./WordleModeForm.vue?vue&type=template&id=dc317984&scoped=true&"
import script from "./WordleModeForm.vue?vue&type=script&lang=ts&"
export * from "./WordleModeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc317984",
  null
  
)

export default component.exports